document.addEventListener('DOMContentLoaded', function () {
  // ✅ 1) Our Brides(목록) 페이지에서는 라이트박스 OFF
  if (document.body.classList.contains('template-page-our-brides')) return;

  // ✅ 2) 라이트박스 HTML 요소
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.querySelector('.lightbox-image');
  const closeBtn = document.querySelector('.lightbox-close');
  if (!lightbox || !lightboxImg) return;

  // ✅ 3) "콜라쥬 섹션" 안의 이미지들만 대상 (아이콘/로고 방지)
  // 필요하면 선택자 더 추가 가능
  const selector = '#MainContent .multicolumn img, #MainContent .collage img';

  function openLightbox(src) {
    if (!src) return;
    lightboxImg.src = src;
    lightbox.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    lightboxImg.src = '';
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  // ✅ 4) 이벤트 위임(페이지에 이미지가 나중에 로드돼도 OK)
  document.addEventListener('click', function (e) {
    const img = e.target.closest(selector);
    if (!img) return;

    // a태그로 감싸져 있으면 페이지 이동 막기
    e.preventDefault();

    // Shopify responsive 이미지 대응
    const src = img.currentSrc || img.src;
    openLightbox(src);
  });

  // 닫기: X
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

  // 닫기: 배경 클릭
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  // 닫기: ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('active')) {
      closeLightbox();
    }
  });
});

